module.exports = __webpack_public_path__ + "img/Vector10.e65c641b.svg";